// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer_2Tq0Z{background-color:#464443}.container_KC2DV{margin:0 auto;max-width:1200px;width:90%;position:relative;display:none}.qrd_div_rLw5T{position:absolute;top:200px;right:0;color:#fff;font-size:.13rem;font-weight:500;text-align:center}.qrd_img_g-Y1p{margin-top:5px;width:90px;height:90px}.qrd_item_jOWMp{margin-bottom:20px}.title_2xk0Q{font-weight:600;font-size:25.6px;color:#fff;padding-top:200px;margin-bottom:40px}.footer_link_P7bST{color:#fff;font-size:12.8px;font-weight:400;margin:16px 0;display:block}.footer_link_P7bST:hover{color:#fff}.link_list_rL5nj{width:70%}.border_div_ltp73{width:100%;height:1px;background-color:#979797;opacity:.9;margin-top:50px}.copyright_div_\\+tIih{text-align:center;color:#fff;font-size:12px;padding:50px 0}.copyright_link_JqiB4{display:inline-block;margin:0}.pointer_events_none_Qf2SE{pointer-events:none}.badge_box_1vPLy{width:300px;margin:0 auto;padding:10px 0}.badge_gHEUP{display:inline-block;text-decoration:none;display:flex;justify-content:center}.badge_gHEUP,.filing_code_5CNz9{height:20px;line-height:20px}.filing_code_5CNz9{margin:0 0 0 5px;color:#939393}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": "footer_2Tq0Z",
	"container": "container_KC2DV",
	"qrd_div": "qrd_div_rLw5T",
	"qrd_img": "qrd_img_g-Y1p",
	"qrd_item": "qrd_item_jOWMp",
	"title": "title_2xk0Q",
	"footer_link": "footer_link_P7bST",
	"link_list": "link_list_rL5nj",
	"border_div": "border_div_ltp73",
	"copyright_div": "copyright_div_+tIih",
	"copyright_link": "copyright_link_JqiB4",
	"pointer_events_none": "pointer_events_none_Qf2SE",
	"badge_box": "badge_box_1vPLy",
	"badge": "badge_gHEUP",
	"filing_code": "filing_code_5CNz9"
};
module.exports = ___CSS_LOADER_EXPORT___;
